import { render, staticRenderFns } from "./DeleteFormDialog.vue?vue&type=template&id=2295b3b2&scoped=true&"
import script from "./DeleteFormDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295b3b2",
  null
  
)

export default component.exports